/**
 * jc-lab.js
 * Upload to: Assets/jc-lab.js
 */
(function(){
  'use strict';
  var els = document.querySelectorAll('.jcl-fade');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function(el){ el.classList.add('jcl-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('jcl-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function(el){ obs.observe(el); });
})();